import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
var _excluded = ["innerRef", "propList", "TargetComponent", "resolver"];
import React from 'react';
import { arrayOfString } from '../helpers';

var PropsResolver = /*#__PURE__*/function (_React$PureComponent) {
  _inheritsLoose(PropsResolver, _React$PureComponent);

  function PropsResolver() {
    return _React$PureComponent.apply(this, arguments) || this;
  }

  var _proto = PropsResolver.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        innerRef = _this$props.innerRef,
        propList = _this$props.propList,
        TargetComponent = _this$props.TargetComponent,
        resolver = _this$props.resolver,
        props = _objectWithoutPropertiesLoose(_this$props, _excluded);

    var propsListSize = propList.length;
    var resolvedProps = {};

    for (var propertyIndex = 0; propertyIndex < propsListSize; propertyIndex++) {
      var propertyName = propList[propertyIndex];
      var propertyValue = props[propertyName];

      if (Array.isArray(propertyValue)) {
        var subProps = [];
        var subPropertySize = propertyValue.length;

        for (var subPropertyIndex = 0; subPropertyIndex < subPropertySize; subPropertyIndex++) {
          subProps[subPropertyIndex] = resolver(propertyValue[subPropertyIndex]);
        }

        resolvedProps[propertyName] = subProps;
      } else {
        resolvedProps[propertyName] = resolver(propertyValue);
      }
    }

    return /*#__PURE__*/React.createElement(TargetComponent, _extends({}, props, resolvedProps, {
      ref: innerRef
    }));
  };

  return PropsResolver;
}(React.PureComponent);

var createContextBasedConnector = function createContextBasedConnector(hook) {
  return function (propList) {
    return function (Component) {
      arrayOfString(propList, 'Prop list');
      return function (props) {
        var resolver = hook();
        return /*#__PURE__*/React.createElement(PropsResolver, _extends({
          TargetComponent: Component,
          propList: propList,
          resolver: resolver
        }, props));
      };
    };
  };
};

export default createContextBasedConnector;
//# sourceMappingURL=create-context-based-connector.js.map